import { getPortionCacheVersions } from '@/api/cache'
import { basicDataCacheKeyPrefix } from '@/utils/cacheConfig'

const state = {
  basicData: new Map(),
  cacheLoadingStatus: false,
  loadingCacheKey: ''
}

const mutations = {
  SET_BASIC_DATA: (state, basicData) => {
    state.basicData.clear()
    state.basicData = basicData
  },
  SET_LOADING_STATUS: (state, cacheLoadingStatus) => {
    state.cacheLoadingStatus = cacheLoadingStatus
  },
  SET_LOADING_CACHE_KEY: (state, loadingCacheKey) => {
    state.loadingCacheKey = loadingCacheKey
  }
}

const actions = {
  loadBasicData({ commit }) {
    return new Promise((resolve, reject) => {
      const blockCacheName = ['Continent', 'AdministrativeDivision', 'Vessel', 'Country', 'Network', 'FeeFcl', 'PortGroup', 'OtherChargeItem', 'PriceServiceAir', 'AirRoute', 'AirRegion',
        'EntityTriggerType', 'MscServiceCode', 'SubLocation', 'Wharf', 'InnerPackage', 'MscImoSort', 'MscSegGroup', 'ChargeUnit', 'CargoInformation']
      getPortionCacheVersions({ excludeCache: blockCacheName.join(',') }).then(res => {
        console.log('cache', res.data)
        const { data } = res
        const strMap = new Map()
        for (const k of Object.keys(data)) {
          strMap.set(basicDataCacheKeyPrefix + k, data[k])
        }
        commit('SET_BASIC_DATA', strMap)
        resolve()
      }).catch(err => {
        reject(err)
      })
    })
  },
  setLoadingStatus({ commit }, cacheLoadingStatus) {
    return new Promise((resolve) => {
      commit('SET_LOADING_STATUS', cacheLoadingStatus)
      resolve()
    })
  },
  setLoadingCacheKey({ commit }, loadingCacheKey) {
    return new Promise((resolve) => {
      commit('SET_LOADING_CACHE_KEY', loadingCacheKey)
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
